import { siteSettings } from "core/siteSettings";
import { transformInternalUrl } from "core/utils/str";

async function doAuthenticatedFetch(url, init, getTokenCallback) {
  const token = await getTokenCallback();
  let headers = { Authorization: `Bearer ${token}` };

  // if the init provided already has headers, add the authorization header
  if (init?.headers) {
    headers = { ...init.headers, ...headers };
  }

  return await fetch(url, { ...init, headers });
}

/**
 * Fetcher for relative urls.
 * Transforms a relative url into a full url based on the current user and does an authenticated fetch
 * @param relativeUrl the relative path to the endpoint in the internal api (E.g. ".../api/cases" becomes "cases")
 * @param init object containing custom settings you want to apply to the fetch
 * @returns {Promise<Response<unknown, unknown>>} A promise that resolves to a Response object
 */
export const internalFetcher = async (relativeUrl, init, getTokenCallback) => {
  const baseUrl = siteSettings.siteApiURL;

  let fullUrl = await transformInternalUrl(`${baseUrl}/${relativeUrl}`);

  return await doAuthenticatedFetch(fullUrl, init, getTokenCallback);
};
